import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";

export const OtherIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props} viewBox="0 0 36 36">
      <path
        d="M15.225 31.8375L12.7875 13.6125C12.6625 12.8125 12.8625 12.1125 13.3875 11.5125C13.9125 10.9125 14.575 10.6125 15.375 10.6125H20.625C21.425 10.6125 22.0875 10.9125 22.6125 11.5125C23.1375 12.1125 23.35 12.8125 23.25 13.6125L20.8125 31.8375C20.7625 32.1625 20.6 32.4375 20.325 32.6625C20.075 32.8875 19.7875 33 19.4625 33H16.5375C16.2125 33 15.925 32.8875 15.675 32.6625C15.425 32.4375 15.275 32.1625 15.225 31.8375ZM18 8.7375C17.225 8.7375 16.55 8.4625 15.975 7.9125C15.425 7.3375 15.15 6.6625 15.15 5.8875C15.15 5.0875 15.425 4.4125 15.975 3.8625C16.525 3.2875 17.2 3 18 3C18.8 3 19.475 3.2875 20.025 3.8625C20.6 4.4125 20.8875 5.075 20.8875 5.85C20.8875 6.65 20.6 7.3375 20.025 7.9125C19.475 8.4625 18.8 8.7375 18 8.7375Z"
        fill="currentColor"
      />
    </SvgIcon>
  );
};
